// extracted by mini-css-extract-plugin
export var card = "HomepageSolutionsGrid-module--card--091c4";
export var grid = "HomepageSolutionsGrid-module--grid--6098b";
export var icon = "HomepageSolutionsGrid-module--icon--ee290";
export var iconContainer = "HomepageSolutionsGrid-module--icon-container--ec2f0";
export var item = "HomepageSolutionsGrid-module--item--45376";
export var text = "HomepageSolutionsGrid-module--text--f1b3c";